// Get an element by data-id
export const getElement = <T extends Element>(dataId: string) =>
  document.querySelector<T>(`[data-id="${dataId}"]`);

export const getElements = <T extends Element>(dataId: string) =>
  document.querySelectorAll<T>(`[data-id="${dataId}"]`);
